import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import Webinar from "./Webinar";

const WebinarLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Webinar List" />
      <Webinar />
    </MasterLayout>
  );
};

export default WebinarLayout;
